export const SELECTED_DATE_FORMAT = 'YYYY-MM-DD';

export const SUBTEXT_FORMAT_LONG = 'ddd, MMM DD, YYYY';

export const SUBTEXT_FORMAT_SHORT = 'ddd, YYYY';

export const DEFAULT_CINEMA_WEEK_START_DAY = 1;

export const STATE_KEY = 'dateSelector';
